import { render } from "./PrivacyStatement.vue?vue&type=template&id=1d8bce6a"
import script from "./PrivacyStatement.vue?vue&type=script&lang=js"
export * from "./PrivacyStatement.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__